import { render, staticRenderFns } from "./PreviousAddEditPartida.vue?vue&type=template&id=35d76b8a"
import script from "./PreviousAddEditPartida.vue?vue&type=script&lang=js"
export * from "./PreviousAddEditPartida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports